(function () {
  var drawers = document.querySelectorAll('[data-hudef-market-drawer]');

  if (!drawers.length) return;

  drawers.forEach(function (drawer) {
    var toggle = drawer.querySelector('[data-hudef-market-toggle]');
    var panel = drawer.querySelector('[data-hudef-market-panel]');
    var form = drawer.querySelector('[data-hudef-market-form]');
    var input = drawer.querySelector('[data-hudef-market-input]');
    var options = drawer.querySelectorAll('[data-hudef-market-option]');

    if (!toggle || !panel || !form || !input) return;

    function closeDrawer() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var countryCode = option.getAttribute('data-country-code');

        if (!countryCode || input.value === countryCode) {
          closeDrawer();
          return;
        }

        input.value = countryCode;
        form.submit();
      });
    });

    document.addEventListener('click', function (event) {
      if (!drawer.contains(event.target)) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  });
})();
